import { requireRuntimeValue, runtimeConfig } from "./runtimeConfig";

const OIDC_AUTHORITY = requireRuntimeValue(
  "VITE_OIDC_AUTHORITY",
  runtimeConfig.oidcAuthority,
);
const OIDC_CLIENT_ID = requireRuntimeValue(
  "VITE_OIDC_CLIENT_ID",
  runtimeConfig.oidcClientId,
);
const APP_REDIRECT_URI = `${window.location.origin}${import.meta.env.BASE_URL}`;

export const sentinelConfig = {
  authority: OIDC_AUTHORITY,
  client_id: OIDC_CLIENT_ID,
  redirect_uri: APP_REDIRECT_URI,
  response_type: "code",
  scope: "openid profile email",
  post_logout_redirect_uri: `${window.location.origin}/logout`,
  // Token renewal is handled by verifyToken/refreshToken so refresh-token
  // rotation cannot race with oidc-client-ts silent renewal.
  automaticSilentRenew: true,
  // Refresh 65 minutes before a two-hour token expires (approximately 55 minutes after iat).
  //accessTokenExpiringNotificationTimeInSeconds: 65 * 60,
  silent_redirect_uri: APP_REDIRECT_URI,
  extraQueryParams: {
    kc_idp_hint: "uhg-ms-id",
  },
} as const;
